import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Eye, LogOut } from "lucide-react";
import { setViewAs } from "@/lib/api";

export const ViewAsContext = createContext(null);
export const useViewAs = () => useContext(ViewAsContext);

// Banner sempre visibile in modalità "Vedi come allievo"
export const ViewAsBanner = ({ name, year }) => {
  const navigate = useNavigate();
  return (
    <div style={{ paddingTop: "env(safe-area-inset-top)" }} className="sticky top-0 z-40 bg-amber-400 text-black border-b-2 border-amber-600 shadow-md" data-testid="view-as-banner" role="status">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
        <p className="font-semibold flex items-start gap-2 break-words min-w-0" data-testid="view-as-text">
          <Eye size={18} className="shrink-0 mt-0.5" /> <span>Stai vedendo come {name || "…"}, anno {year}. Sola lettura</span>
        </p>
        <Button onClick={() => navigate("/admin")} data-testid="view-as-exit" className="min-h-11 bg-black text-white hover:bg-black/80 shrink-0"><LogOut size={16} className="mr-1.5" /> Esci</Button>
      </div>
    </div>
  );
};

// Attiva la modalità prima del primo render dei figli e la spegne all'uscita
export const ViewAsScope = ({ children }) => {
  const { uid } = useParams();
  const [sp] = useSearchParams();
  const [value] = useState(() => {
    const v = { uid, year: sp.get("anno") || "" };
    setViewAs(v);
    return v;
  });
  // Re-imposta a ogni mount (StrictMode smonta/rimonta gli effetti in sviluppo)
  useEffect(() => { setViewAs(value); return () => setViewAs(null); }, [value]);
  return <ViewAsContext.Provider value={value}>{children}</ViewAsContext.Provider>;
};

export const ViewAsButton = ({ uid, year }) => {
  const navigate = useNavigate();
  return (
    <Button size="sm" variant="outline" data-testid={`view-as-${uid}`} onClick={() => navigate(`/admin/vedi-come/${encodeURIComponent(uid)}?anno=${encodeURIComponent(year || "")}`)}>
      <Eye size={14} className="mr-1.5" /> Vedi come allievo
    </Button>
  );
};
